import {Node} from 'tiptap';
import {replaceText} from 'tiptap-commands';
import {Suggestions} from 'tiptap-extensions';

export default class TagPlugin extends Node {
    templateEditor;

    get name() {
        return 'tag';
    }

    get defaultOptions() {
        return {
            matcher: {
                char: '[',
                allowSpaces: false,
                startOfLine: false,
            },
            mentionClass: 'wysiwyg__tag',
            suggestionClass: 'mention-suggestion',
        };
    }

    get schema() {
        return {
            attrs: {
                tag: {},
            },
            group: 'inline',
            inline: true,
            selectable: false,
            atom: true,
            toDOM: node => [
                'span',
                {
                    'class': this.options.mentionClass,
                },
                `[${node.attrs.tag}]`,
            ],
            parseDOM: [
                {
                    tag: 'span',
                    getAttrs: dom => {
                        let tag = dom.innerText;
                        if (tag.startsWith('[') && tag.endsWith(']')) {
                            tag = tag.slice(1, tag.length - 1);
                        }
                        return {tag};
                    },
                },
            ],
        };
    }

    commands({schema}) {
        return attrs => replaceText(null, schema.nodes[this.name], attrs);
    }

    get plugins() {
        return [
            Suggestions({
                command: ({range, attrs, schema}) => replaceText(range, schema.nodes[this.name], attrs),
                appendText: ' ',
                matcher: this.options.matcher,
                items: this.options.items,
                onEnter: this.options.onEnter,
                onChange: this.options.onChange,
                onExit: this.options.onExit,
                onKeyDown: this.options.onKeyDown,
                onFilter: this.options.onFilter,
                suggestionClass: this.options.suggestionClass,
            }),
        ];
    }
}



// WEBPACK FOOTER //
// ./src/components/tiptap/TagPlugin.js